var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"silvia-embed-wrapper",class:{ 'menu-expanded': !_vm.isMenuCollapsed }},[_c('iframe',{ref:"iframeRef",staticClass:"silvia-embed",attrs:{"src":_vm.embedUrl,"frameborder":"0","allow":"clipboard-write; microphone"}})])}
var staticRenderFns = []

export { render, staticRenderFns }